'use client';

import { AnimatePresence, m } from 'framer-motion';
import { FC, useEffect, useState } from 'react';

import { LazyMotionWrapper } from '../LazyMotionWrapper/LazyMotionWrapper';
import { SubscribeFormEnd } from './SubscribeFormEnd';
import { SubscribeFormInterest } from './SubscribeFormInterest';
import { SubscribeFormStart } from './SubscribeFormStart';

const TRANSLATION_DISTANCE = 40;

const variants = {
  enter: {
    y: TRANSLATION_DISTANCE,
    opacity: 0,
  },
  center: {
    zIndex: 1,
    y: 0,
    opacity: 1,
  },
  exit: {
    zIndex: 0,
    y: -TRANSLATION_DISTANCE,
    opacity: 0,
  },
};

export const SubscribeForm: FC = () => {
  const [currentStep, setCurrentStep] = useState<'start' | 'interest' | 'end'>('start');
  const [email, setEmail] = useState<string>('');

  useEffect(() => {
    if (globalThis.window !== undefined) {
      globalThis.window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [currentStep]);

  return (
    <div>
      <LazyMotionWrapper>
        <AnimatePresence mode="wait" initial={false}>
          {currentStep === 'start' && (
            <m.div
              key="start"
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ ease: 'easeInOut', duration: 0.3 }}
            >
              <SubscribeFormStart
                onSuccess={(email) => {
                  setEmail(email);
                  setCurrentStep('interest');
                }}
              />
            </m.div>
          )}
          {currentStep === 'interest' && (
            <m.div
              key="interest"
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ ease: 'easeInOut', duration: 0.3 }}
            >
              <SubscribeFormInterest email={email} onSuccess={() => setCurrentStep('end')} />
            </m.div>
          )}
          {currentStep === 'end' && (
            <m.div
              key="end"
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{ ease: 'easeInOut', duration: 0.3 }}
            >
              <SubscribeFormEnd />
            </m.div>
          )}
        </AnimatePresence>
      </LazyMotionWrapper>
    </div>
  );
};
